import styled from 'styled-components';

export const Promo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 91px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 120px;
    background-color: #f9f9f9;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    @media (min-width: 980px) {
        margin: 0 auto;
        width: 960px;
    }
`;

export const Title = styled.h2`
    display:block;
    margin: 0;
    margin-bottom: 22px;
    text-align: center;
    font-size: 40px;
    color: #000000;
`;

export const List = styled.ul`
    padding: 0;
    font-size: 14px;
    line-height: 25px;
    columns: 2;
    column-gap: 180px;
    width: 100%;
    list-style: none;
    @media (max-width: 1024px) {
        column-gap: 40px;
    }
    @media (max-width: 640px) {
        columns: 1;
    }
    @media (min-width: 980px) {
        width: 960px;
    }
`;

export const Text = styled.li`
    text-align: center;
    font-size: 14px;
    line-height: 25px;
    margin-bottom: 30px;
    & span {
        font-weight: 900;
    }
    @media (min-width: 550px) {
        text-align: inherit;
        height: 'auto';
    }
    @media (min-width: 980px) {
        width: 395px;
    }
`;
